import script from "./ProxyContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ProxyContent.vue?vue&type=script&setup=true&lang=js"

import "./ProxyContent.vue?vue&type=style&index=0&id=72aba21e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72aba21e"]])

export default __exports__